/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Project.Entrypoint
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
} from '@tanstack/vue-query';
import {
  unref,
} from 'vue';

import { customInstance } from '../../../lib/axios-instance';

import type {
  MarkAsReadNotificationCommand,
  NotificationsGetNotificationsParams,
  PagedResultOfNotificationDto,
} from '../../../lib/api/schemas';
import type { ErrorType, BodyType } from '../../../lib/axios-instance';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';
import type {
  MaybeRef,
} from 'vue';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const notificationsGetNotifications = (
  params: MaybeRef<NotificationsGetNotificationsParams>,
  options?: SecondParameter<typeof customInstance>, signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<PagedResultOfNotificationDto>(
    { url: '/notifications', method: 'GET',
      params: unref(params), signal,
    },
    options);
};

export const getNotificationsGetNotificationsQueryKey = (params: MaybeRef<NotificationsGetNotificationsParams>) => {
  return ['notifications', ...(params ? [params] : [])] as const;
};

export const getNotificationsGetNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof notificationsGetNotifications>>, TError = ErrorType<void>>(params: MaybeRef<NotificationsGetNotificationsParams>, options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsGetNotifications>>, TError, TData>>; request?: SecondParameter<typeof customInstance> },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getNotificationsGetNotificationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsGetNotifications>>> = ({ signal }) => notificationsGetNotifications(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof notificationsGetNotifications>>, TError, TData>;
};

export type NotificationsGetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsGetNotifications>>>;
export type NotificationsGetNotificationsQueryError = ErrorType<void>;

export function useNotificationsGetNotifications<TData = Awaited<ReturnType<typeof notificationsGetNotifications>>, TError = ErrorType<void>>(
  params: MaybeRef<NotificationsGetNotificationsParams>, options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsGetNotifications>>, TError, TData>>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNotificationsGetNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

export const notificationsGetUnreadNotificationsCount = (

  options?: SecondParameter<typeof customInstance>, signal?: AbortSignal,
) => {
  return customInstance<number>(
    { url: '/notifications/unread-count', method: 'GET', signal,
    },
    options);
};

export const getNotificationsGetUnreadNotificationsCountQueryKey = () => {
  return ['notifications', 'unread-count'] as const;
};

export const getNotificationsGetUnreadNotificationsCountQueryOptions = <TData = Awaited<ReturnType<typeof notificationsGetUnreadNotificationsCount>>, TError = ErrorType<void>>(options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsGetUnreadNotificationsCount>>, TError, TData>>; request?: SecondParameter<typeof customInstance> },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getNotificationsGetUnreadNotificationsCountQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsGetUnreadNotificationsCount>>> = ({ signal }) => notificationsGetUnreadNotificationsCount(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof notificationsGetUnreadNotificationsCount>>, TError, TData>;
};

export type NotificationsGetUnreadNotificationsCountQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsGetUnreadNotificationsCount>>>;
export type NotificationsGetUnreadNotificationsCountQueryError = ErrorType<void>;

export function useNotificationsGetUnreadNotificationsCount<TData = Awaited<ReturnType<typeof notificationsGetUnreadNotificationsCount>>, TError = ErrorType<void>>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsGetUnreadNotificationsCount>>, TError, TData>>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNotificationsGetUnreadNotificationsCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

export const notificationsMarkAsReadNotification = (
  markAsReadNotificationCommand: MaybeRef<MarkAsReadNotificationCommand>,
  options?: SecondParameter<typeof customInstance>) => {
  markAsReadNotificationCommand = unref(markAsReadNotificationCommand);

  return customInstance<void>(
    { url: '/notifications/read', method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: markAsReadNotificationCommand,
    },
    options);
};

export const getNotificationsMarkAsReadNotificationMutationOptions = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkAsReadNotification>>, TError, { data: BodyType<MarkAsReadNotificationCommand> }, TContext>; request?: SecondParameter<typeof customInstance> },
): UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkAsReadNotification>>, TError, { data: BodyType<MarkAsReadNotificationCommand> }, TContext> => {
  const mutationKey = ['notificationsMarkAsReadNotification'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsMarkAsReadNotification>>, { data: BodyType<MarkAsReadNotificationCommand> }> = (props) => {
    const { data } = props ?? {};

    return notificationsMarkAsReadNotification(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsMarkAsReadNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsMarkAsReadNotification>>>;
export type NotificationsMarkAsReadNotificationMutationBody = BodyType<MarkAsReadNotificationCommand>;
export type NotificationsMarkAsReadNotificationMutationError = ErrorType<void>;

export const useNotificationsMarkAsReadNotification = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkAsReadNotification>>, TError, { data: BodyType<MarkAsReadNotificationCommand> }, TContext>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient): UseMutationReturnType<
  Awaited<ReturnType<typeof notificationsMarkAsReadNotification>>,
  TError,
  { data: BodyType<MarkAsReadNotificationCommand> },
  TContext
> => {
  const mutationOptions = getNotificationsMarkAsReadNotificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
